import type { DemoSourceType } from '../types';
import type { TwitterSourceValue } from './types';

export const previewTwitterSources: DemoSourceType<TwitterSourceValue> = {
  'twitter-mrbeast': {
    label: 'Twitter: @MrBeast',
    source: {
      id: 'kgtebkhi',
      name: 'X',
      platform: 'twitter',
      showReplies: true,
      showReposts: true,
      showPosts: true,
      connectionType: 'twitterProfile',
      status: 'success',
      source: 'MrBeast',
      sourcePID: '0c0ea29f-90c0-4213-91ce-e06b712e8cbe'
    }
  },
  'twitter-mirrortravel': {
    label: 'Twitter: @MirrorTravel',
    source: {
      id: 'kgtebkhu',
      name: 'X',
      platform: 'twitter',
      showReplies: true,
      showReposts: true,
      showPosts: true,
      connectionType: 'twitterProfile',
      status: 'success',
      source: 'MirrorTravel',
      sourcePID: 'b6129db5-6818-4235-9164-a16cc5e98af4'
    }
  },
  'twitter-music': {
    label: 'Twitter: #Music',
    source: {
      id: 'kgteb123',
      name: 'X',
      platform: 'twitter',
      showReplies: true,
      showReposts: true,
      showPosts: true,
      connectionType: 'twitterHashtag',
      status: 'success',
      source: 'music',
      sourcePID: 'd4b3d405-e15a-434a-b666-6abe24486ba8'
    }
  }
};
